



























import { AppHeading, AppPicture, AppText } from '@/uikit';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

export default {
  name: 'InterviewCard',

  components: {
    AppButtonNew,
    AppHeading,
    AppPicture,
    AppText,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    linkToVacancy() {
      return {
        name: 'vacancy',
        params: { id: this.item.vacancy_id },
      };
    },
    placeholder() {
      return require('@/assets/placeholders/LO_placeholder_image.jpg');
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/InterviewCard/InterviewCard.vue